import type { ElementType, HTMLAttributes } from "react";
import type { SpaceScale } from "./Stack";
import "./layout.css";

export interface GridProps extends HTMLAttributes<HTMLDivElement> {
  /** Gap between cells, from the --space-* scale. Default 4 (var(--space-4)). */
  gap?: SpaceScale;
  /** Number of equal-width columns (1-12). For responsive/auto-fit grids, pass a className instead. */
  columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  as?: ElementType;
}

/** CSS grid layout. Use instead of inline style={{ display: "grid", gridTemplateColumns, gap }}. */
export function Grid({ gap = 4, columns = 1, as: Component = "div", className, ...rest }: GridProps) {
  const classes = ["ui-grid", `ui-gap-${gap}`, className].filter(Boolean).join(" ");
  return (
    <Component
      className={classes}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      {...rest}
    />
  );
}
